import { render, staticRenderFns } from "./input-date.vue?vue&type=template&id=3c06284e&scoped=true"
import script from "./input-date.vue?vue&type=script&lang=js"
export * from "./input-date.vue?vue&type=script&lang=js"
import style0 from "./input-date.vue?vue&type=style&index=0&id=3c06284e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06284e",
  null
  
)

export default component.exports